module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-05-2e54187747dc5dd464c8c8b7b557a274.jpg";